import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Container, Typography } from '@mui/material';
import { getPublicStatus } from '../utils/stakeholderApi';
import StakeholderBetList from '../components/shapeup/StakeholderBetList';

/**
 * The public status page: no login, resolved entirely from an opaque token. A
 * private, rotated, or un-published token 404s, which reads here as "no longer
 * available" rather than an error.
 */
const PublicStatusPage = () => {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [gone, setGone] = useState(false);

  const fetchData = useCallback(async () => {
    setLoading(true);
    setGone(false);
    try {
      const payload = await getPublicStatus(token);
      setData(payload);
    } catch (err) {
      setGone(true);
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 10 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (gone) {
    return (
      <Container maxWidth="sm" sx={{ py: 10, textAlign: 'center' }}>
        <Typography variant="h5" gutterBottom>This status page is no longer available.</Typography>
        <Typography variant="body1" color="text.secondary">
          The link may have been turned off or replaced. Ask whoever shared it for a new one.
        </Typography>
      </Container>
    );
  }

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <StakeholderBetList view={data?.view} bets={data?.bets} />
    </Container>
  );
};

export default PublicStatusPage;
